
import { Component, Vue } from "vue-property-decorator";
import AskGoOn from "./ask-go-on.vue";
import Config from "@/config/config";
import Auth from "@/lib/common/auth";

@Component({
  components: { AskGoOn }
})
export default class CheckUserChange extends Vue {
  visible = false;
  isChecking = false;
  lastUserToken = "";
  timer = 0;

  async checkForUpdates() {
    if (!this.lastUserToken) {
      this.lastUserToken = Auth.token;
      return;
    }

    if (this.lastUserToken !== Auth.token && Auth.token) {
      clearInterval(this.timer);
      this.visible = true;
    }
  }

  start() {
    // 每 checkUpdatesInterval(默认值为1) 分钟检查一次
    this.checkForUpdates();
    this.timer = setInterval(this.checkForUpdates, 60 * 1000);
  }

  handleVisibilitychange() {
    if (document.hidden) {
      stop();
    } else {
      if (!this.isChecking) {
        this.isChecking = true;
        this.checkForUpdates().finally(() => {
          this.isChecking = false;
          this.start();
        });
      }
    }
  }

  stop() {
    clearInterval(this.timer);
  }

  reload() {
    window.location.href = Config.aiInterviewHost;
  }

  mounted() {
    this.start();
    document.addEventListener("visibilitychange", this.handleVisibilitychange);
  }

  beforeDestory() {
    this.stop();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilitychange
    );
  }
}
